import React from "react";
import styles from "./ota-backup-start.module.scss";
import BackupIcon from "@src/assets/svg/upload-icon-black.svg";
import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import { Title } from "@src/components/atoms/title/title";
import { useDispatch } from "react-redux";
import {
  updateModalsCloseDrawerModal,
  updateShowOtaCreateBackupModal,
} from "@src/reducers/your-reducer";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "@src/components/molecules/render-if-user-has-permission/render-if-user-has-permission";
import {
  CONFIGURATION_BACKUP_DRAWER_MODAL,
  FIRMWARE,
} from "@src/cloud-connect/ota-update/constants";
import { useFeatureFlag } from "@src/hooks/use-feature-flag";

interface OtaBackupStart {
  otaActiveView?: string;
}
const cssClassName = "ota-backup-start";

const OtaBackupStart = ({ otaActiveView }: OtaBackupStart) => {
  const dispatch = useDispatch();

  const i18n = useI18N();

  const permission = "initiate-update-process";

  const texts = {
    noBackupsAvailableText: i18n(
      "modules.otaBackupStart.noBackupsAvailableText",
    ),
    createFirmwareBackup: i18n("modules.otaBackupStart.createFirmwareBackup"),
    createConfigurationBackup: i18n(
      "modules.otaBackupStart.createConfigurationBackup",
    ),
    createBackupText: i18n("modules.otaBackupStart.createBackupText"),
  };

  const title =
    otaActiveView === FIRMWARE
      ? texts.createFirmwareBackup
      : texts.createConfigurationBackup;

  const showCreateBackup = () => {
    if (otaActiveView === FIRMWARE) {
      dispatch(updateShowOtaCreateBackupModal(true));
      return;
    }

    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: CONFIGURATION_BACKUP_DRAWER_MODAL,
      }),
    );
  };
  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__no-backup`]}>
        {texts.noBackupsAvailableText}
      </p>
      <RenderIfUserHasPermission permission={permission}>
        <>
          <Title text={title} tag={"h2"} />
          <div className={styles[`${cssClassName}__cta`]}>
            <ButtonWithIcon
              fun={() => showCreateBackup()}
              text={texts.createBackupText}
              icon={BackupIcon}
            />
          </div>
        </>
      </RenderIfUserHasPermission>
    </div>
  );
};

export default OtaBackupStart;
